import { render, staticRenderFns } from "./TextElement.vue?vue&type=template&id=bae71968&scoped=true&"
import script from "./TextElement.vue?vue&type=script&lang=ts&"
export * from "./TextElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae71968",
  null
  
)

export default component.exports